import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
export const platTypeList = [
  { label: "今日头条", value: 1, icon: "jrtt" },
  { label: "广点通", value: 2, icon: "gdt" },
  { label: "快手", value: 3, icon: "kuaishou" },
  { label: "今日头条2.0", value: 4, icon: "jrtt" },
  { label: "Google", value: 5, icon: "google" },
  { label: "Facebook", value: 6, icon: "facebook" },
];

export const pickerOptions = {
  shortcuts: [
    {
      text: "当天",
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        picker.$emit("pick", [start, end]);
        setTimeout(() => {
          changeshortcutclass("当天", picker.$el);
        }, 0);
      },
    },
    {
      text: "昨天",
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24);
        end.setTime(end.getTime() - 3600 * 1000 * 24);
        picker.$emit("pick", [start, end]);
        setTimeout(() => {
          changeshortcutclass("昨天", picker.$el);
        }, 0);
      },
    },
    {
      text: "最近一周",
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
        picker.$emit("pick", [start, end]);
        setTimeout(() => {
          changeshortcutclass("最近一周", picker.$el);
        }, 0);
      },
    },
    {
      text: "最近一个月",
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
        setTimeout(() => {
          changeshortcutclass("最近一个月", picker.$el);
        }, 0);
      },
    },
    {
      text: "最近2个月",
      onClick (picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
        picker.$emit("pick", [start, end]);
        setTimeout(() => {
          changeshortcutclass("最近2个月", picker.$el);
        }, 0);
      },
    },
  ],
  onPick: function ({ maxDate, minDate }) {
    clearallshortcutclass(this.$el);
    console.log(maxDate, minDate);
  },
  // disabledDate: function(time) {
  //   return time.getTime() > Date.now();
  // }
  disabledDate: function (date) {
    if (new Date().getTime() - date.getTime() > 0) {
      return false;
    }
    return true;
  },
};